export default {
      id: "footer-logo-usage",
      viewBox: "0 0 213 38",
      url: __webpack_public_path__ + "assets/img/svg/sprite.svg#footer-logo",
      toString: function () {
        return this.url;
      }
    }